import React, { Component } from 'react';
import { Card, CardText } from 'material-ui/Card';
import Form from '../Common/Form.react';
import TextField from '../Common/TextField';
import CalendarActions from '../../actions/CalendarActionCreator';

class CalendarForm extends Component {

    constructor() {
        super(...arguments);
        this.state = {
            isEdit: (this.props.routeParams.id !== undefined && !!this.props.routeParams.id.match(/\d+/)),

            form: {
                name: '',
                description: '',
            }
        };
    }

    submitForm (model) {
        return CalendarActions.save(model);
    }

    render () {

      let url = '/dashboard/calendars';
      return(
            <Form
                title="New calendar"
                onSave={this.submitForm}
                onCancel={this.onCancel}
                redirectTo={url}
            >
                <Card className="cent-card">
                    <CardText>
                        <TextField
                            name="name"
                            value={this.state.form.name}
                            validations="minLength:2,maxLength:255"
                            validationError="Please use only letters, at least 2"
                            hintText="Name"
                            floatingLabelText="Name"
                            required
                        />
                        <TextField
                            name="description"
                            value={this.state.form.description}
                            hintText="Description"
                            floatingLabelText="Description"
                        />
                    </CardText>
                </Card>
            </Form>
      );
    }

    onCancel() {
        window.location.href = '/dashboard/calendars'
    }

    onChange() {
    }
}

export default CalendarForm;
